import { removeStrategy, fetchStrategyList } from "./thunk";

export const strategyListCases = (builder) => {
  builder.addCase(fetchStrategyList.pending, (state) => {
    state.loading = true;
    state.errorMessage = "";
  });
  builder.addCase(fetchStrategyList.fulfilled, (state, action) => {
    state.strategies = action.payload;
    state.loading = false;
  });
  builder.addCase(fetchStrategyList.rejected, (state, action) => {
    state.loading = false;
    state.errorMessage = action.payload.error;
  });
};

export const removeStrategyCases = (builder) => {
  builder.addCase(removeStrategy.pending, (state, action) => {
    state.errorMessage = "";
    state.isLoadingDelete = true;
    state.refetchStrategies = false;
    state.deletingStrategyId = action.meta.arg;
  });
  builder.addCase(removeStrategy.fulfilled, (state) => {
    state.errorMessage = "";
    state.isLoadingDelete = false;
    state.refetchStrategies = true;
    state.deletingStrategyId = null;
  });
  builder.addCase(removeStrategy.rejected, (state, action) => {
    state.isLoadingDelete = false;
    state.refetchStrategies = false;
    state.deletingStrategyId = null;
    state.errorMessage = action.payload.error;
  });
};

export const setErrorMessageReducer = (state, action) => {
  state.errorMessage = action.payload;
};

export const setBacktestStatusLog = (state, action) => {
  if (Array.isArray(action.payload)) {
    state.backtestStatusLog = [];
  } else {
    state.backtestStatusLog.push(action.payload);
  }
};

export const setStartedBacktestReducer = (state, action) => {
  state.startedBacktest = action.payload;
};

export const setIsBacktestCompleteReducer = (state, action) => {
  state.isBacktestComplete = action.payload;
};

export const setStrategyTypeReducer = (state, action) => {
  state.strategyType = action.payload;
};

export const setCurrentBacktestIdReducer = (state, action) => {
  state.currentBacktestId = action.payload;
};
